<template>
  <div class="app-container comment-post-detail">
    <basic-container>
      <el-tabs v-model="activeName" @tab-click="onTabShow">
        <el-tab-pane label="基本资料" name="detail">
          <el-row class="comment-post-detail-item">
            <el-col :span="2" class="head">ID:</el-col>
            <el-col :span="16">{{postDetail.id}}</el-col>
          </el-row>
          <el-row class="comment-post-detail-item" >
            <el-col :span="2">内容:</el-col>
            <el-col :span="16">
              <div class="post-content" v-if="postDetail.contentType == 1">
                <div v-html="postDetail.content"></div>
              </div>
              <div class="post-content post-content-text" v-else>{{postDetail.content}}</div>
            </el-col>
          </el-row>
          <el-row class="comment-post-detail-item">
            <el-col :span="2">发布者:</el-col>
            <el-col :span="16">
              <a href="javascript:void(0);" @click="toMemberDetail(postDetail.postedBy.id);"
                class="comment-post-detail-item-button">
                {{ postDetail.postedByName }}</a>
            </el-col>
          </el-row>
          <el-row class="comment-post-detail-item">
            <el-col :span="2">原文标题:</el-col>
            <el-col :span="16">{{postDetail.topicTitle}}</el-col>
          </el-row>
          <el-row class="comment-post-detail-item">
            <el-col :span="2">原文链接:</el-col>
            <el-col :span="16">
              <a class="comment-post-detail-item-button" :href="postDetail.topicUrl" target="_blank">{{postDetail.topicUrl}}</a>
            </el-col>
          </el-row>
          <el-row class="comment-post-detail-item">
            <el-col :span="2">点赞:</el-col>
            <el-col :span="16">{{postDetail.likeCount}}</el-col>
          </el-row>
          <el-row class="comment-post-detail-item">
            <el-col :span="2">状态:</el-col>
            <el-col :span="16">{{postDetail.status}}</el-col>
          </el-row>
          <el-row class="comment-post-detail-item" v-if="postDetail.status === '已下架'">
            <el-col :span="2">下架原因:</el-col>
            <el-col :span="16">{{postDetail.banComment}}</el-col>
          </el-row>
          <el-row class="comment-post-detail-item">
            <el-col :span="2">发布时间:</el-col>
            <el-col :span="16">{{postDetail.postTime}}</el-col>
          </el-row>
        </el-tab-pane>

        <el-tab-pane label="点赞列表" name="like">
          <el-table :data="postLikeData" stripe
            style="width:90%" tooltip-effect="dark">
            <el-table-column align="center" prop="likeTime" label="点赞时间" width="200"></el-table-column>
            <el-table-column align="center" prop="nickname" label="用户"></el-table-column>
          </el-table>
          <el-pagination :page-size="postLikePage.pageSize"
                         :page-sizes="postLikePage.pageSizes"
                         :current-page="postLikePage.currentPage"
                         :total="postLikePage.total"
                         :layout="postLikePage.layout"
                         @current-change="postLikeCurrentChange"
                         @size-change="postLikeSizeChange">
          </el-pagination>
        </el-tab-pane>
      </el-tabs>

    </basic-container>
  </div>
</template>

<script>
import { fetchPostLikeList } from '@/api/post/post'
import { getCommentPost } from '@/api/radar/comment'
import postLikeList from '@/mixins/post/like-list';

const initDetail = vm => {
  getCommentPost(vm.id).then(response => {
    let data = response.data;
    if (response.status == 200) {
      formatPostDetail(vm.postDetail, data.data);
    } else {
      vm.$message({
        showClose: true,
        message: '无法查看该评论贴详情',
        type: 'error'
      });
    }
  }).catch(error => {
    vm.$message({
      message: '获取评论贴详情失败',
      type: 'error'
    });
  });
}

const formatPostDetail = (vm, data) => {
  // 评论贴详情格式化
  vm.id = data.id;
  vm.banComment = data.banComment;
  vm.contentType = data.contentType;

  if (!data.content) vm.content = '--';
  else vm.content = data.content;

  if (!data.postedBy) vm.postedByName = '--';
  else if (!data.postedBy.name) vm.postedByName = '--';
  else {
    vm.postedByName = data.postedBy.name;
    vm.postedBy = data.postedBy;
  }

  if (data.circleId) vm.circleId = data.circleId;

  if (data.isActive == 0 ) vm.status = '已删除';
  else if (data.isBanned == 0) vm.status = '已上架';
  else if (data.isBanned == 1) vm.status = '已下架';
  else vm.status = '--';

  vm.likeCount = data.likeCount || 0;

  if (!data.postTime) vm.postTime = '--';
  else vm.postTime = data.postTime;

  vm.isAnonymous = data.isAnonymous;

  if (!data.postTopic) {
    vm.topicTitle = '--';
    vm.topicUrl = '--';
  } else if (data.postTopic.title && !data.postTopic.url) {
    vm.topicTitle = data.postTopic.title;
    vm.topicUrl = '--';
  } else if (!data.postTopic.title && data.postTopic.url) {
    vm.topicTitle = '--';
    vm.topicUrl = data.postTopic.url;
  } else {
    vm.topicTitle = data.postTopic.title;
    vm.topicUrl = data.postTopic.url;
  }
}

export default {
  mixins: [postLikeList],
  data () {
    return {
      id: 0,
      activeName: 'detail',
      postDetail:{
        id: undefined,
        topicTitle: '',
        topicUrl: '',
        contentType: undefined,
        content: '',
        postedBy: undefined,
        postedByName: '',
        circleId: undefined,
        status: '',
        isActive: '',
        postTime: '',
        isAnonymous: 0,
        banComment: ''
      },
    }
  },
  watch: {
    $route () {
      this.id = this.$route.params.id;
      initDetail(this);
    }
  },
  mounted () {
    this.id = this.$route.params.id;
    initDetail(this);
  },
  methods: {
    onTabShow(tab) {
      switch (tab.name) {
        case 'like':
          this.initPostLike();
          break;
      }
    },
    toMemberDetail(postedById) {
      // 评论贴详情里点击发布者姓名，链接转到该发布者的会员详情
      this.$router.push({
        path: '/upms/member/detail/' + postedById,
      });
    },
  }
}
</script>

<style lang="scss" scoped>

.comment-post-detail {
  .comment-post-detail-item {
    font-size: 16px;
    margin: 10px 0;
    &-button {
      margin: 0 0;
      color: #409EFF;
      text-align: center;
    }
  }
  &-item-picture-right {
    font-size: 16px;
    display: table-cell;
    &-item {
      display: inline-block;
      margin-right: 5px;
      margin-top: 5px;
    }
    &-poster {
      position: relative;
      &-icon {
        position: absolute;
        color: #ffffff;
        top: 30px;
        left: 30px;
        font-size: 40px;
      }
      &-icon:hover {
        color: rgba(249, 129, 55, 0.9);
      }
    }
  }
}

.vue-poll .ans-cnt .ans .bg{
  position: absolute;
  width: 0;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 0;
  background-color: #409eff;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
.post-content {
  border: 1px solid #eee;
  padding: 10px;
  /deep/ .mc-img {
    max-width: 100%;
  }
  /deep/ a {
    text-decoration: none;
    color: #01396B;
  }
}

.post-content-text {
  white-space: pre-wrap;
}

.mc-img {
  max-width: 100%;
}
/deep/.el-dialog {
  box-shadow: none;
  background: none;
}
/deep/.el-dialog__headerbtn {
  right: -20px;
  font-size: 20px;
}
</style>
